var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProcessReports01 = function SvgProcessReports01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "process_reports-01_svg2__a",
    x1: -44.37,
    x2: 96.5,
    y1: 131.28,
    y2: -9.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#process_reports-01_svg2__a",
    id: "process_reports-01_svg2__b",
    x1: -36.8,
    x2: 104.07,
    y1: 138.86,
    y2: -2.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#process_reports-01_svg2__a",
    id: "process_reports-01_svg2__c",
    x1: -25.41,
    x2: 115.46,
    y1: 150.25,
    y2: 9.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#process_reports-01_svg2__a",
    id: "process_reports-01_svg2__d",
    x1: -2.52,
    x2: 138.35,
    y1: 173.13,
    y2: 32.27
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#process_reports-01_svg2__a",
    id: "process_reports-01_svg2__e",
    x1: 0.34,
    x2: 141.2,
    y1: 175.99,
    y2: 35.12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#process_reports-01_svg2__a",
    id: "process_reports-01_svg2__f",
    x1: 8.6,
    x2: 149.47,
    y1: 184.26,
    y2: 43.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#process_reports-01_svg2__a",
    id: "process_reports-01_svg2__g",
    x1: 16.87,
    x2: 157.74,
    y1: 192.52,
    y2: 51.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#process_reports-01_svg2__a",
    id: "process_reports-01_svg2__h",
    x1: 20.71,
    x2: 161.58,
    y1: 196.36,
    y2: 55.49
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#process_reports-01_svg2__a",
    id: "process_reports-01_svg2__i",
    x1: 30.64,
    x2: 171.51,
    y1: 206.3,
    y2: 65.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#process_reports-01_svg2__a",
    id: "process_reports-01_svg2__j",
    x1: 40.58,
    x2: 181.45,
    y1: 216.23,
    y2: 75.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#process_reports-01_svg2__a",
    id: "process_reports-01_svg2__k",
    x1: 27.8,
    x2: 168.67,
    y1: 203.46,
    y2: 62.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#process_reports-01_svg2__a",
    id: "process_reports-01_svg2__l",
    x1: 60.41,
    x2: 201.28,
    y1: 236.07,
    y2: 95.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#process_reports-01_svg2__a",
    id: "process_reports-01_svg2__m",
    x1: 60.41,
    x2: 201.28,
    y1: 236.07,
    y2: 95.2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2.94 85.29c1.63 0 2.95-1.32 2.95-2.95v-70.6c0-2.88 2.34-5.23 5.23-5.23h120.9c2.89 0 5.23 2.35 5.23 5.23v10.59c0 1.63 1.32 2.94 2.94 2.94s2.95-1.32 2.95-2.94V11.74c0-6.13-4.99-11.12-11.12-11.12H11.12C4.99.62 0 5.61 0 11.74v70.61c0 1.63 1.32 2.95 2.94 2.95Z",
    style: {
      fill: "url(#process_reports-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.14 69.01a2.94 2.94 0 0 0-2.94 2.95v44.02c0 2.71 2.2 4.91 4.91 4.91h12.57c2.71 0 4.91-2.2 4.91-4.91V33.37c0-2.71-2.2-4.91-4.91-4.91H21.11c-2.71 0-4.91 2.2-4.91 4.91v26.8c0 1.63 1.32 2.95 2.94 2.95s2.94-1.32 2.94-2.95V34.35h10.6v80.64h-10.6V71.95c0-1.63-1.32-2.95-2.94-2.95Z",
    style: {
      fill: "url(#process_reports-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.04 115.97V20.01c0-2.71-2.2-4.91-4.91-4.91H50.56c-2.71 0-4.91 2.2-4.91 4.91v95.96c0 2.71 2.2 4.91 4.91 4.91h12.57c2.71 0 4.91-2.2 4.91-4.91m-5.89-.98h-10.6v-94h10.6z",
    style: {
      fill: "url(#process_reports-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.49 52.66c0-2.71-2.2-4.91-4.91-4.91H80.01c-2.71 0-4.91 2.2-4.91 4.91v63.32c0 2.71 2.2 4.91 4.91 4.91h12.57c2.71 0 4.91-2.2 4.91-4.91zm-5.89 62.33H81V53.64h10.6z",
    style: {
      fill: "url(#process_reports-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.86 139.45H16c-1.63 0-2.94 1.32-2.94 2.94s1.32 2.95 2.94 2.95h35.86c1.63 0 2.94-1.32 2.94-2.95s-1.32-2.94-2.94-2.94",
    style: {
      fill: "url(#process_reports-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.86 155.98H16c-1.63 0-2.94 1.32-2.94 2.94s1.32 2.95 2.94 2.95h35.86c1.63 0 2.94-1.32 2.94-2.95s-1.32-2.94-2.94-2.94",
    style: {
      fill: "url(#process_reports-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.86 172.51H16c-1.63 0-2.94 1.32-2.94 2.95s1.32 2.94 2.94 2.94h35.86c1.63 0 2.94-1.32 2.94-2.94s-1.32-2.95-2.94-2.95",
    style: {
      fill: "url(#process_reports-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3 139.45H63.06c-1.63 0-2.95 1.32-2.95 2.94s1.32 2.95 2.95 2.95H86.3c1.63 0 2.95-1.32 2.95-2.95s-1.32-2.94-2.95-2.94",
    style: {
      fill: "url(#process_reports-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.11 158.92c0 1.63 1.32 2.95 2.95 2.95h29.92c1.63 0 2.95-1.32 2.95-2.95s-1.32-2.94-2.95-2.94H63.06c-1.63 0-2.95 1.32-2.95 2.94",
    style: {
      fill: "url(#process_reports-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.06 178.4h36.6c1.63 0 2.94-1.32 2.94-2.94s-1.32-2.95-2.94-2.95h-36.6c-1.63 0-2.95 1.32-2.95 2.95s1.32 2.94 2.95 2.94",
    style: {
      fill: "url(#process_reports-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.98 134.28c-.51-2.91-3.3-4.86-6.21-4.35l-11.32 1.99c-.49-.93-1.01-1.85-1.58-2.74l7.39-8.81c.92-1.1 1.36-2.49 1.23-3.92-.12-1.43-.8-2.72-1.89-3.64l-8.55-7.17a5.367 5.367 0 0 0-7.55.66l-7.39 8.81c-.98-.4-1.97-.77-2.98-1.08v-11.49c0-2.96-2.4-5.36-5.36-5.36h-10.63V34.1c0-1.63-1.32-2.94-2.95-2.94s-2.94 1.32-2.94 2.94v79.94q-1.515.48-2.97 1.08l-7.33-8.74V83.4c0-1.63-1.32-2.94-2.94-2.94s-2.95 1.32-2.95 2.94v21.28c-1.26.43-.99.36-10.26 8.14-.12.1-.23.2-.34.31V31.47h10.6v40.16c0 1.63 1.32 2.94 2.95 2.94s2.94-1.32 2.94-2.94V30.49c0-2.71-2.2-4.91-4.91-4.91h-12.57c-2.71 0-4.91 2.2-4.91 4.91v85.49c0 2.71 2.2 4.91 4.91 4.91h1.08c5.27 6.28 3.74 4.45 6.97 8.31-.57.89-1.1 1.8-1.58 2.74l-11.32-1.99a5.36 5.36 0 0 0-6.21 4.35l-1.94 10.98c-.51 2.91 1.44 5.7 4.35 6.21l11.33 2c.14 1.05.32 2.09.55 3.11l-9.95 5.75a5.36 5.36 0 0 0-1.96 7.32l5.58 9.66a5.36 5.36 0 0 0 7.32 1.96l9.96-5.75c.78.71 1.58 1.39 2.42 2.03l-3.93 10.81c-.64 1.75-.3 3.62.73 5.02H11.12c-2.89 0-5.23-2.35-5.23-5.23V94.13c0-1.63-1.32-2.95-2.95-2.95S0 92.5 0 94.13v94.04c0 6.13 4.99 11.12 11.12 11.12h120.9c1.09 0 2.15-.16 3.15-.46 3.81 1.4 6.57-.39 7.51-2.97l3.94-10.81c1.06.05 2.1.05 3.16 0l3.93 10.81c1 2.75 4.05 4.23 6.87 3.21l10.49-3.82c2.78-1.01 4.21-4.09 3.2-6.87l-3.94-10.81c.84-.64 1.64-1.32 2.42-2.03l9.96 5.75c2.56 1.48 5.84.61 7.32-1.96l5.58-9.66c1.48-2.56.6-5.84-1.96-7.32l-9.95-5.75c.23-1.03.41-2.07.55-3.11l11.33-2c2.6-.45 4.43-2.73 4.43-5.28 0-.64.08.02-2.02-11.92Zm-20.52 22.93c-.38 1.3.18 2.69 1.36 3.37l11.43 6.59-5.05 8.74c-17.51-10.11-11-7.96-20.04-1.88a2.95 2.95 0 0 0-1.13 3.45l4.52 12.4-9.49 3.45-4.51-12.4a2.94 2.94 0 0 0-3.08-1.92c-10.91 1.18-7.23-4.66-14.14 14.33l-2.36-.86-7.13-2.59c6.93-19.02 5.92-12.2-1.62-20.07a2.96 2.96 0 0 0-3.6-.51l-11.44 6.6-5.05-8.74 11.43-6.59a2.945 2.945 0 0 0 1.35-3.37c-.61-2.09-.98-4.26-1.13-6.45a2.955 2.955 0 0 0-2.43-2.71l-13-2.29 1.75-9.94c19.87 3.51 13.05 3.74 19.47-5.08.8-1.1.75-2.6-.12-3.63-.04-.05-5.55-6.61-8.49-10.11 5.52-4.63 3.79-3.17 7.73-6.49 5.08 6.05 3.18 3.79 8.48 10.11a2.934 2.934 0 0 0 3.55.75c1.9-.93 3.98-1.7 6.15-2.23 1.29-.31 2.2-1.46 2.24-2.78v-13.28h10.09v13.2c0 1.36.93 2.54 2.24 2.86 2.12.52 4.19 1.27 6.15 2.23 1.22.6 2.68.29 3.55-.75l8.48-10.11 7.73 6.49-8.48 10.11a2.945 2.945 0 0 0-.12 3.63c1.29 1.76 2.39 3.67 3.27 5.66a2.955 2.955 0 0 0 3.21 1.71l12.99-2.29 1.75 9.94c-19.95 3.51-13.53 1-16.56 11.44Z",
    style: {
      fill: "url(#process_reports-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.19 121.88c-14.56 0-26.4 11.85-26.4 26.41s11.85 26.41 26.4 26.41 26.41-11.85 26.41-26.41-11.84-26.41-26.41-26.41m0 46.92c-11.31 0-20.51-9.2-20.51-20.51s9.2-20.51 20.51-20.51 20.52 9.2 20.52 20.51-9.2 20.51-20.52 20.51",
    style: {
      fill: "url(#process_reports-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.39 148.29c0 13.23 16.03 19.7 25.27 10.47 5.78-5.78 5.78-15.15 0-20.93-9.36-9.36-25.27-2.6-25.27 10.47Zm8.5 6.3c-5.56-5.56-1.67-15.21 6.3-15.21 4.93 0 8.91 3.99 8.91 8.91 0 7.86-9.57 11.94-15.21 6.3",
    style: {
      fill: "url(#process_reports-01_svg2__m)"
    }
  }));
};
export default SvgProcessReports01;